import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { ProcedimentoAuditoriaFormComponent } from 'src/app/pages/procedimento-auditoria-form/procedimento-auditoria-form.component';

@Injectable()
export class ProcedimentoAuditoriaGuard
  implements CanDeactivate<ProcedimentoAuditoriaFormComponent> {
  canDeactivate(
    component: ProcedimentoAuditoriaFormComponent
  ): Observable<boolean> | boolean {
    if (!component.visualizar) {
      if (component?.salvar) { return true; }
        if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    }
    else { return true; }
  }
}
